<div class="az-footer ht-40 page-footer fixed-bottom">
  <div class="container ht-100p pd-t-0-f">
    <div class="d-sm-flex justify-content-center justify-content-sm-between py-2 w-100">
      <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © Fasten 2024 | {{appVersion}}</span>
      <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center"><a href="https://www.fastenhealth.com/" externalLink>Fasten Health: Your Journey, Your Records, Your Control</a></span>
    </div>
  </div><!-- container -->
</div><!-- az-footer -->
